import { useState, useEffect } from 'react';
import { useIsMobile } from '../useIsMobile/useIsMobile.js';

/**
 * The breakpoints of the TitanTheme.
 */
var breakpoints = {
  xs: 0,
  s: 768,
  m: 1024,
  l: 1280,
  xl: 1420,
  xxl: 1920
};
/**
 * Returns the current breakpoint based on the window width.
 * @returns {Breakpoint} The current breakpoint.
 */
var getBreakpoint = function () {
  var windowWidth = window.innerWidth;
  if (windowWidth >= breakpoints.xxl) return 'xxl';
  if (windowWidth >= breakpoints.xl) return 'xl';
  if (windowWidth >= breakpoints.l) return 'l';
  if (windowWidth >= breakpoints.m) return 'm';
  if (windowWidth >= breakpoints.s) return 's';
  return 'xs';
};
/**
 * Hook that returns the current breakpoint based on the window width.
 * @returns {Breakpoint} The current breakpoint.
 */
var useCurrentBreakpoint = function () {
  var isMobile = useIsMobile();
  var _a = useState(isMobile ? 's' : 'l'),
    currentBreakpoint = _a[0],
    setCurrentBreakpoint = _a[1];
  /* Update the breakpoint on mount and when the window is resized */
  useEffect(function () {
    setCurrentBreakpoint(getBreakpoint());
    var handleResize = function () {
      setCurrentBreakpoint(getBreakpoint());
    };
    window.addEventListener('resize', handleResize);
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, []);
  return currentBreakpoint;
};

export { breakpoints, useCurrentBreakpoint };
//# sourceMappingURL=useCurrentBreakpoint.js.map
